import { portableFilename } from '../../project/dropmap/filename';
import { downloadBrowserFile } from '../../browser/download';
import type { VectorExportFormat, VectorExportScope } from './model';

export const GEOJSON_MIME_TYPE = 'application/geo+json';
export const CSV_MIME_TYPE = 'text/csv;charset=utf-8';

export interface DataExportFile {
  readonly blob: Blob;
  readonly filename: string;
}

export function vectorExportFilename(
  layerName: string,
  format: VectorExportFormat,
  scope: VectorExportScope,
): string {
  const extension = format === 'geojson' ? 'geojson' : 'csv';
  const withoutExtension = layerName.replace(new RegExp(`\\.${extension}$`, 'i'), '');
  const base = scope === 'selected' ? `${withoutExtension}-selected` : withoutExtension;
  return portableFilename(base, extension, 'Placeio Maps data');
}

export function tableExportFilename(tableName: string): string {
  return portableFilename(tableName, 'csv', 'Placeio Maps table');
}

export function createTextDataExportFile(
  text: string,
  filename: string,
  mimeType: string,
): DataExportFile {
  return { blob: new Blob([text], { type: mimeType }), filename };
}

export function downloadDataExportFile(file: DataExportFile): string {
  return downloadBrowserFile(file);
}
